import { Spinner, Text, styled } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';

const CenterContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100vh;
`;

export interface LoadingProps {
	showText?: boolean;
	text?: string;
}

export const Loading = (props: LoadingProps) => {
	const { showText, text } = props;
	return (
		<CenterContent>
			<Spinner variant="large" />
			{showText ?? <Text>{text ? text : 'Cargando'}</Text>}
		</CenterContent>
	);
};
